module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAoklEQVQ4T2N8tuT8/xcLzjH8//OPgRTAyMLEIB6lz8B4znXu//+/SdMMswhkCONZh9n/SbEZXS3lBvz//3+AXTDwYUAVF7AKcTKo9nsz3EjfwCDgoMjArSnG8PPxRwYWQU6GZ7NP441lxnMuc/8zsjIzCLurMrzZcoOBQ0GAgVWEm+Hvp58MTBysDJ/PPcVpADghPVt07v+LRefJSspikXoMAHV7Q49+NJ4mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay.png
// module id = 321P
// module chunks = 1